const message = {
  msg_1: 'Contact Details',
  msg_2: 'Contact Number',
  msg_3: `Contact Email`,
  msg_4: 'Contact Address: 7F, Block B, Wanhai Building, 1031 Nanhai Avenue, Nanshan District, Shenzhen',
}

export default message